// extracted by mini-css-extract-plugin
export default {"holder":"MmM1L7ZKwqtB6Hfk3PLF"};